export default class ApiService {

	static get $inject(){
		return [
			'$q', '$http', '$cookies',
			'ApiService'
		];
	}

	constructor($q, $http, $cookies,
	            ApiService){

		this.api = ApiService.api;
		this.errors = ApiService.errors;
		this.successes = ApiService.successes;
		
		this.$q = $q;
		this.$http = $http;
		this.$cookies = $cookies;

	}

	//a.res(href="https://en.wikipedia.org/wiki/Snake_case", target="_blank") Snake Case.

	get service(){
		return {

			me: {
				humanName: 'User account',
				description: 'Get currently logged-in user',
				request: {
					//contentType: 'Content-Type: application/json;charset=UTF-8',
					type: 'GET',
					route: '/account/me',
					data: [
						/*{ name: 'email', type: 'String', description: 'Login' },
						 { name: 'password', type: 'String', description: 'Password' }*/
					]
					//example: angular.toJson({ email: '3', password: '4444' })
				},
				response: {
					success: {
						data: [
							{ name: 'userId', type: 'Integer', description: 'User id' },
							{ name: 'login', type: 'String', description: 'User login' },
							{ name: 'name', type: 'String', description: 'User name' },
							{ name: 'lastName', type: 'String', description: 'User last name' }
						]
					},
					error: {
						data: [
							{ name: 'message', type: 'String', description: 'Error description (optional)' }
						]
					}
				},
				submit: ()=>
					this.$http({
						url: this.api + '/account/me',
						method: 'GET',
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			}
		}
	}

}



/** WEBPACK FOOTER **
 ** ./src/main/apiTest/services/api.service.account.js
 **/